import { useQuery } from '@tanstack/react-query';
import { pricingQueries } from '@/services/pricingApi';
import { POPULAR_COUNTRY_CODES } from '@/config/countries';
import { CountryRate } from '@/types/pricing';

/**
 * Helper hook to get countries data in different formats
 */
export const useCountriesData = () => {
  const pricingQuery = useQuery(pricingQueries.pricing());

  return {
    ...pricingQuery,
    countries: pricingQuery.data?.countries || [],
    popularCountries: POPULAR_COUNTRY_CODES
      .map(code => pricingQuery.data?.countries.find((c: CountryRate) => c.countryCode === code))
      .filter((c): c is CountryRate => c !== undefined),
    stats: pricingQuery.data?.stats,
  };
};
